export const projectsIniValues = {
  title: "",
  banner: "",
  _id: "",
  description: "",
};
